module.exports = __webpack_public_path__ + "de52df05c7481542bedee4b2a8a81754.pdf";